import classNames from 'classnames';
import TermOfUse from 'components/ComachiTermOfUse';
import React, {useState} from 'react';
import Style from 'styles/components/application.module.scss';
import { graphql, useStaticQuery } from 'gatsby';

const Application = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          comachiApplicationUrl
        }
      }
    }
  `);
  const applicationUrl = data.site.siteMetadata.comachiApplicationUrl;
  // 利用規約を最後までスクロールされたかのフラグ
  const [isReadToBottom, setIsReadToBottom] = useState(false);
  // 利用規約への同意フラグ
  const [isAgreed, setIsAgreed] = useState(false);
  const [val, setVal] = React.useState(['js']);

  const checkBoxStyle = {
    opacity: isReadToBottom ? '1' : '0.3',
  };

  const scrollHander = e => {
    const remainingHeight =
      (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) / e.target.scrollHeight;
    if (remainingHeight <= 0.02) {
      // 下部4%までスクロールした場合に利用規約を読んだと判断
      setIsReadToBottom(true);
    }
  };
  const handleChange = e => {
    if (val.includes(e.target.value)) {
      setVal(val.filter(item => item !== e.target.value));
      setIsAgreed(false);
    } else {
      setVal([...val, e.target.value]);
      setIsAgreed(true);
    }
  };

  return (
    <section id='application' className={Style.application}>
      <div>
        <h2 className={classNames(Style.application__title)}>
          <span>お申し込み</span>
        </h2>
        <div className={Style.application__termsOfUse} id='scrollTermsOfUse' onScroll={scrollHander}>
          <span id='scrollTermsOfUseContent'>
            <TermOfUse />
          </span>
        </div>
        <div className={Style.application__checkbox} style={checkBoxStyle} id='checkAgree'>
          <input
            type = 'checkbox'
            value = 'checked'
            onChange = {handleChange} 
            checked = {val.includes('checked')} 
            disabled = {!isReadToBottom} 
            id = 'agreement' 
          ></input>
          <label htmlFor="agreement" className={Style.application__checkboxLabel}>
          <b>comachicartサービス利用規約</b>・<b>comachicartアプリストア及び当社アプリ利用の特約</b>・<b>プライバシーポリシー</b>に同意する
          </label>
        </div>
        <input
          type = 'button'
          onClick = {() => window.open(applicationUrl, '_blank')} 
          value ='申し込む'
          className = {Style.application__button} 
          id = 'application'
          disabled={!isAgreed}
        />
      </div>
      <a href='https://e-ize.jp/tokushoho/' target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a>
    </section>
  );
};

export default Application;
